import { IBar, IPitch } from "../../../../../common/types";

import { IState } from "./interfaces";

export const isBarsSame = (barA: IBar, barB: IBar) => {
    if (barA.notes.length !== barB.notes.length) return false;
    for (let n = 0; n < barA.notes.length; n++) {
        const noteA = barA.notes[n];
        const noteB = barB.notes[n];
        if (noteA.r && noteB.r && noteA.l === noteB.l && noteA.d === noteB.d && noteA.t === noteB.t) continue;
        if (noteA.r || noteB.r) return false;
        if (
            noteA.l !== noteB.l ||
            noteA.d !== noteB.d ||
            noteA.t !== noteB.t ||
            (noteA.p as IPitch).s !== (noteB.p as IPitch).s ||
            (noteA.p as IPitch).o !== (noteB.p as IPitch).o ||
            (noteA.p as IPitch).a !== (noteB.p as IPitch).a ||
            !!noteA.tie !== !!noteB.tie
        ) {
            return false;
        }
    }
    return true;
};


const threshold = 50;

export const isNearAnyDrop = ({ drops, left, top }: { drops: IState["drops"], left: number, top: number}) => {
    let target: number | null = null;
    drops.forEach((drop, index) => {
        if (Math.abs(drop.t - top) < threshold && Math.abs(drop.l - left) < threshold) {
            target = index;
        }
    });
    return (typeof target === "number" ? target : null) as number | null;
};

export const randomizeOrder = (total: number) => {
    let order: number[] = [];
    let n;
    let i;

    if (total === 2) {
        return [1, 0];
    } else if (total === 1) {
        return [0];
    }
    for (let a = 0; a < total; a++) {
        while (order.length === a) {
            n = Math.floor(Math.random() * total);
            i = -1;
            for (let b = 0; b < order.length; b++) {
                if (order[b] === n) {
                    i = b;
                    break;
                }
            }

            if (i === -1) {
                order.push(n);
            }
        }
    }

    return order;
};
